// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bw-4";
export var collapsed = "_bw-1";
export var headerBar = "_bw-0";
export var leftHeaderContent = "_bw-3";
export var subjectContainer = "_bw-2";